import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../config/config";
import { getAuthToken } from "../../utils/token";
import Select from "react-select";
export default function DispatchForm({
    selectedRow,
    onSuccess,
}) {

    const [loading, setLoading] = useState(false);
    const [productOptions, setProductOptions] = useState([]);
    const updatedOptions = useMemo(() => {
        return [{ label: "All", value: 0 }, ...(productOptions || [])];
    }, [productOptions]);
    const [listPo, setListPo] = useState([]);
    const updatePo = useMemo(() => {
        return [{ label: "All", value: 0 }, ...(listPo || [])];
    })
    const [formData, setFormData] = useState({
        po_number: "",
        product_id: "",
        product_name: "",
        dispatch_date: new Date().toISOString().split("T")[0],
        dispatch_qty: "",
        remarks: "",
    });
    const fetchProductList = async () => {
        const token = getAuthToken();
        if (!token) return;
        setLoading(true);
        try {
            const response = await axios.get(`${config.API}/product/list`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setProductOptions(
                response?.data?.products?.map((plist) => ({
                    value: plist.id,
                    label: plist.name,
                })) || []
            );
        } catch (err) {
            console.error("Error fetching products:", err);
        } finally {
            setLoading(false);
        }
    };
    const poList = async () => {
        const token = getAuthToken();
        if (!token) return;
        setLoading(true);
        try {
            const response = await axios.get(`${config.API}/purchaseorder/list`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            console.log(response);
            setListPo(
                response?.data?.data.map((polist) => ({
                    value: polist.id,
                    label: polist.po_number,
                })) || []
            );
        } catch (err) {
            console.error("Error fetching products:", err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchProductList();
        poList();
        if (selectedRow) {
            setFormData({
                po_number: selectedRow.po_number || "",
                product_id: selectedRow.product_id || "",
                product_name: selectedRow.product_name || "",
                dispatch_date: new Date().toISOString().split("T")[0],
                dispatch_qty: "",
                remarks: "",
            });
        }
    }, [selectedRow]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = getAuthToken();
        if (!token) {
            toast.error("Authentication failed.");
            return;
        }
        if (!formData.dispatch_qty) {
            toast.error("Please enter dispatch quantity.");
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(
                `${config.API}/supervisor/dispatchentry`,
                {
                    po_number: formData.po_number,
                    product_id: formData.product_id,
                    dispatch_date: formData.dispatch_date,
                    dispatch_qty: formData.dispatch_qty,
                    remarks: formData.remarks,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            toast.success(response.data.message || "Dispatch saved successfully");
            if (onSuccess) {
                onSuccess();
            }
            setFormData({
                ...formData,
                po_number: "",
                product_id: "",
                product_name: "",
                dispatch_date: new Date().toISOString().split("T")[0],
                dispatch_qty: "",
                remarks: "",
            });
        } catch (error) {
            toast.error(
                error.response?.data?.message ||
                "Failed to save dispatch."
            );

        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card shadow">

            <div className="card-header bg-primary text-white">
                Dispatch Entry
            </div>

            <div className="card-body">

                <form onSubmit={handleSubmit}>

                    <div className="row">

                        <div className="col-md-6 mb-3">
                            <label className="form-label">
                                PO Number
                            </label>
                            <Select
                                options={listPo}
                                placeholder="Select PO Number"
                                isClearable
                                value={
                                    listPo.find(
                                        option => option.value === formData.po_number
                                    ) || null
                                }
                                onChange={(selected) => {
                                    setFormData(prev => ({
                                        ...prev,
                                        po_number: selected ? selected.value : "",
                                    }));
                                }}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">
                                Product Name
                            </label>
                            <Select
                                options={productOptions}
                                placeholder="Select Product"
                                isClearable
                                value={
                                    productOptions.find(
                                        option => option.value === formData.product_id
                                    ) || null
                                }
                                onChange={(selected) => {
                                    if (selected) {
                                        setFormData(prev => ({
                                            ...prev,
                                            product_id: selected.value,
                                            product_name: selected.label,
                                        }));
                                    } else {
                                        setFormData(prev => ({
                                            ...prev,
                                            product_id: "",
                                            product_name: "",
                                        }));
                                    }
                                }}
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">
                                Dispatch Date
                            </label>

                            <input
                                type="date"
                                className="form-control"
                                name="dispatch_date"
                                value={formData.dispatch_date}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="col-md-6 mb-3">
                            <label className="form-label">
                                Dispatch Quantity
                            </label>

                            <input
                                type="number"
                                className="form-control"
                                name="dispatch_qty"
                                value={formData.dispatch_qty}
                                onChange={handleChange}
                                min="1"
                                required
                            />
                        </div>

                        <div className="col-md-12 mb-3">
                            <label className="form-label">
                                Remarks
                            </label>

                            <textarea
                                rows="4"
                                className="form-control"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                                placeholder="Enter Remarks"
                            />
                        </div>

                    </div>

                    <button
                        className="btn btn-primary"
                        disabled={loading}
                    >
                        {loading ? "Saving..." : "Save Dispatch"}
                    </button>

                </form>

            </div>

        </div>
    );
}